export interface Tag {
  type: string; // represents thinking, transfer, progress, research, interrupt, SimulationDiff, summarization
  progressId: string | null; // for progress it will be string for others it will be null
  content: string; // represents content for that tag
  text: string; // for progress we store text?? For some reason
  isComplete: boolean; // flag to keep track if the current tag is complete or not
  isStreaming: boolean; // flag to keep track if the current tag is currently streaming or not.
}

export interface SimulationDiffData {
  workitem_id: string;
  workitem_name: string;
  simulation_diff: {
    summary: {
      total_changes: number;
      operations: {
        added: number;
        updated: number;
        deleted: number;
        dependency_updates: number;
      };
    };
    tasks: Array<{
      task_id: string;
      operation: string;
      data: any;
    }>;
  };
  id: string;
}

export interface MessageInterrupt {
  type: 'question_ui' | 'simulation_approval_ui' | 'SimulationDiff';
  data: any;
}

export interface Message {
  text: string;
  isBot: boolean;
  id: string; // user-7654326789, bot-76545789980
  messageId: number | null;
  isTimelineExpanded: boolean;
  tags: any[];
  isEditing?: boolean; // Make this optional to maintain backwards compatibility
  created_at?: string;
  modified_at?: string;
  queued_at?: string;
  isError?: boolean; // Flag to indicate if this is an error message
  // List of interrupts associated with this message (normalized)
  interrupts?: MessageInterrupt[];
}

export interface ChatMap {
  [chatId: string]: Chat;
}

export interface Chat {
  chatId: number | string;
  title: string;
  projectId: string;
  createdAt: string;
  createdBy: string;

  messages: Message[];
  isStreaming: boolean; // represents if event stream is streaming (will have to add logic for specific chat_id)
  isLoading: boolean; // represents if sent, create, event stream is loading
}

export interface ChatHistory {
  chat_id: number;
  title: string;
  project_id: string;
  created_at: string;
  created_by: string;
  updated_at: string;
  is_pinned?: boolean;
}

export interface ChatHistoryByDate {
  older: ChatHistory[];
  today: ChatHistory[];
  yesterday: ChatHistory[];
}

export interface ActiveTag extends Tag {
  originalIndex?: number;
  stage?: string;
  stepId?: string;
  groupedProgress?: Tag[];
}

export interface HandleSubquestionsRequest {
  entity: string;
  isnew: boolean;
  is_first_time: boolean;
  entity_id?: string;
  entity_name?: string;
}

export interface HandleSubquestionResponse {
  sub_questions: Subquestion[]
}

export interface Subquestion {
  question: string;
  prompt: string;
}

export type ResearchLink = {
  title: string;
  url: string;
  host?: string;
  favicon?: string
};

export interface ContextInfo {
  pageName: string,
  chatButtonText: string,
  headerTitle: string,
  welcomeMessage: string,
  contextPayload: ContextPayload,
  entity_name: string
}

export interface ContextPayload {
  context_type: string,
  project_id?: string,
  entity: string,
  entity_id: string,
  page: string
}

export interface ChatEntity {
  entity: string;
  entityId: string | null;
}

export enum ChatTimelineThinkingMode {
  COMPACT = 'compact',
  OFF = 'off',
}